import React from 'react'

const HomeIcon = () => {
	return(
<svg xmlns="http://www.w3.org/2000/svg" width="31.539" height="18.255" viewBox="0 0 31.539 18.255"><g stroke="#fff" fill="none"><path d="M13.192 17.135l-1.057-.013-.046-6.621-4.589-.097.017 6.6-.955-.011-5.562-.113v-9.914l8.367-5.79 9.013 4.987 12.159-1.111v6.092l-11.916 6.106zm-4.009-16.105l22.038 3.886zM18.453 6.106l.3 11.144M5.064 16.978l9.89.2"/></g></svg>
	)
}

export default HomeIcon